import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { PatientsService } from '../../resource/add-patients-master/patients-master.service';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { VOBService } from '../../services/vob.service';
import { exportPDF, Group } from '@progress/kendo-drawing';
import { CoreHelperService } from 'src/app/providers/core-helper/core-helper.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonNotificationService } from 'src/app/common/service/common-notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-vob-pdf-export',
  templateUrl: './vob-pdf-export.component.html',
  styleUrls: ['./vob-pdf-export.component.scss']
})

export class VobPdfExportComponent implements OnInit {

  @Input() public paramVobId: number = 0;
  @Input() public paramExportFileName: string = "";
  @Input() public paramFacilitySiteId: string = "";
  @Input() public paramIsGroupFacility: boolean = false;
  @Input() public paramFacilityDocumentBlobPath: string = "";
  @Input() public vobFileDate: Date = new Date();
  @Input() public vobFileFacilityName: string = "";
  @Input() public isAutoDownload: boolean = false;
  @ViewChild("vobpdf") public vobpdf: PDFExportComponent;
  @ViewChild('downloadButton') downloadButton: ElementRef;
  vobId: number = 0;
  vobExportFileName: string = "";
  isHide: boolean = true;
  facilitySiteId: string = "";
  facilityDocumentBlobPath: string = "";
  isGroupFacility: boolean = false;

  constructor(
    private _patientservice: PatientsService,
    private _vobService: VOBService,
    private _coreHelperService: CoreHelperService,
    public sanitizer: DomSanitizer,
    private _messageService: CommonNotificationService,
  ) { }

  async ngOnInit() {
    this.vobExportFileName = this.paramExportFileName;
    this.vobId = this.paramVobId;
    this.facilitySiteId = this.paramFacilitySiteId;
    this.isGroupFacility = this.paramIsGroupFacility;
    this.facilityDocumentBlobPath = this.paramFacilityDocumentBlobPath;

    await this.loadVobExportData();
  }

  //VOB Export to PDF
  vobNotesExportData: any;
  vobOtherExportData: any;
  vobExclusionExportDataOnly: any;
  vobPreCertSerivesData: any;
  vobPharmacyExportData: any;
  hasPharmacyInfo: boolean = false;

  async loadVobExportData() {
    await lastValueFrom(this._patientservice.getVobExportByVobId(this.vobId)).then((response) => {
      if (response.apiStatus) {
        this.vobOtherExportData = response.apiData.filter((item) => item.container !== "Notes" && item.container !== "Disclaimer" && item.container !== "Pre-Certification Services");
        this.vobPreCertSerivesData = response.apiData.filter((item) => item.container === "Pre-Certification Services");
        this.vobNotesExportData = response.apiData.filter((item) => (item.container === "Notes" || item.container === "Disclaimer") && item.container !== "Pre-Certification Services");
        this.vobExclusionExportDataOnly = this.vobOtherExportData.filter((item) => (item.container === "Exclusions" || item.container === "Call Details"));
        this.vobPharmacyExportData = this.vobOtherExportData.filter((item) => item.container === "Pharmacy Information" || item.container === "Pre-Certification Requirements");
        let justPharamacyData = this.vobOtherExportData.filter((item) => item.container === "Pharmacy Information");
        this.hasPharmacyInfo = (justPharamacyData != undefined && justPharamacyData != null && justPharamacyData.length > 0);
      } else {
        this._vobService.isViewPDF = false;
      }
    });
  }

  async saveVobPdfForEndUser(pdfComponent: PDFExportComponent) {
    pdfComponent.saveAs();
  }

  showUploadProgressMessage: boolean = false;

  closeUploadProgressMessage() {
    this._vobService.isViewPDF = false;
    this.showUploadProgressMessage = false;
    this.isHide = false;
  }

  async uploadVobPdfToSharepointFolder(pdfComponent: PDFExportComponent) {
    let isProduction = environment.production;
    let isGroupFacility = this.isGroupFacility;
    this.showUploadProgressMessage = true;
    let fileFormData: FormData = new FormData();
    await pdfComponent.export().then((group: Group) => exportPDF(group)).then(async (dataUri) => {
      fileFormData.append("file", this.dataURLtoFile(dataUri, pdfComponent.fileName));
      fileFormData.append("fileName", this.vobExportFileName);
      fileFormData.append("facilityName", this.vobFileFacilityName);
      fileFormData.append("receivedDate", this._coreHelperService.getUtcDate(this.vobFileDate).toJSON());
      fileFormData.append("vobId", this.vobId.toString());
      fileFormData.append("isGroupFacility", isGroupFacility.toString());
      fileFormData.append("facilitySiteId", this.facilitySiteId.toString());
      fileFormData.append("isLive", isProduction.toString());
      await lastValueFrom(this._vobService.uploadPatientVobFileToSharepoint(fileFormData)).then(async (response) => {
        if (response.apiStatus) {
          this._messageService.displaySuccessMessage("The PDF is processed and uploaded at Sharepoint folder successfully.");
        } else {
          this._messageService.displayError("Unable to be Processing PDF at this time please try again later.");
        }
      });
    });
  }

  public dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  public jsonStringToArray(stringData: string) {
    return JSON.parse(stringData);
  }

  searchStrings = ["Notes", "Disclaimer"];
  containsStringUsingSome(searchString: string) {
    return this.searchStrings.some(s => searchString.toLowerCase().includes(s.toLowerCase()));
  }

  getColumnKeys(data): string[] {
    if (data.length > 0) {
      return Object.keys(data[0]);
    }
    return [];
  }

  getSanitizedNotesHtml(item: any): SafeHtml {
    if (item == undefined) return '';
    const arr = item;
    if (!arr) return '';
    const html = arr.replace(/\n/g, '<br/>');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  async uploadPdfToCereusBlobStorage(pdfComponent: PDFExportComponent) {
    let isProduction = environment.production;
    let isGroupFacility = this.isGroupFacility;
    this.showUploadProgressMessage = true;
    let fileFormData: FormData = new FormData();
    await pdfComponent.export().then((group: Group) => exportPDF(group)).then(async (dataUri) => {
      fileFormData.append("file", this.dataURLtoFile(dataUri, pdfComponent.fileName));
      fileFormData.append("fileName", this.vobExportFileName);
      fileFormData.append("facilityName", this.vobFileFacilityName);
      fileFormData.append("receivedDate", this._coreHelperService.getUtcDate(this.vobFileDate).toJSON());
      fileFormData.append("vobId", this.vobId.toString());
      fileFormData.append("isGroupFacility", isGroupFacility.toString());
      fileFormData.append("facilitySiteId", this.facilitySiteId.toString());
      fileFormData.append("isLive", isProduction.toString());
      fileFormData.append("facilityDocumentBlobPath", this.facilityDocumentBlobPath);
      await lastValueFrom(this._vobService.uploadVobPdfToCereusBlobStorage(fileFormData)).then(async (response) => {
        if (response.apiStatus) {
          this._messageService.displaySuccessMessage("The PDF is processed and uploaded at Sharepoint folder successfully.");
        } else {
          this._messageService.displayError("Unable to be Processing PDF at this time please try again later.");
        }
      });
    });
  }
}
